<template>
  <div class="visit">
    <!-- 搜索框 -->
    <SearchBar @search="search" :checkList="checkList" />

    <!-- 表单 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      @selection-change="handleSelectionChange"
      fit
      highlight-current-row
      height="560"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" width="60" label="编号">
        <template slot-scope="scope">
          {{ pageSize * (pageIndex - 1) + (scope.$index + 1) }}
        </template>
      </el-table-column>
      <el-table-column label="楼盘名" align="center">
        <template slot-scope="scope">
          {{ scope.row.house && scope.row.house.houseName }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="租购意向" align="center">
        <template slot-scope="scope">
          <span>
            {{ scope.row.isSaleTxt || '--' }}
          </span>
        </template>
      </el-table-column>

      <el-table-column label="推荐人" align="center">
        <template slot-scope="scope">
          <span>{{ handledecrypt(scope.row.reward) || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户名" align="center">
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.customerName) || '--' }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="客户电话" align="center">
        <template slot-scope="scope">
          {{
            handledecrypt(scope.row.customerPhone, scope.row.isShowAllPhone) ||
            '--'
          }}
        </template>
      </el-table-column>

      <el-table-column
        class-name="status-col"
        label="身份证号码"
        align="center"
      >
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.lastSixId) || '--' }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="企业名称" align="center">
        <template slot-scope="scope">
          {{ scope.row.companyName || '--' }}
        </template>
      </el-table-column>

      <!-- 指定接待销售员 和 现场接待销售员这两个字段显示相互替换以下 2023-08-17 后端吴鸿洲 -->
      <!-- 字段需要替换回来，2024-12-26 后端周康
        最后一次确认 ，【内部】产地开始赚小程序项目群N0037 邱贺回复 图片 2024/12/3015:30:32
      -->
      <el-table-column
        class-name="status-col"
        label="指定接待销售员"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.salesPersonName || '--' }}
        </template>
      </el-table-column>

      <el-table-column
        class-name="status-col"
        label="现场接待销售员"
        align="center"
      >
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.factSalesPersonName) || '--' }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="客服" align="center">
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.customerServiceName) || '--' }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="状态" align="center">
        <template slot-scope="scope">
          {{ statusList[scope.row.status] }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="报备时间" align="center">
        <template slot-scope="scope">
          {{ scope.row.createTime || '' }}
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="看房有效期"
        align="center"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.availableTime || '' }}</div>
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="实际到访时间"
        align="center"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.arriveTime || '' }}</div>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="修改人" align="center">
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.updater) || '--' }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="修改时间" align="center">
        <template slot-scope="scope">
          <!-- <div v-if="scope.row.reviewTime !== null">
            {{ scope.row.reviewTime.split(' ')[0] }}
          </div>
          <div v-if="scope.row.reviewTime !== null">
            {{ scope.row.reviewTime.split(' ')[1] }}
          </div> -->
          <div>{{ scope.row.updationTime }}</div>
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="备注" align="center">
        <template slot-scope="scope">
          {{ scope.row.remark || '' }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="审批意见" align="center">
        <template slot-scope="scope">
          {{ scope.row.reviewOpinion || '--' }}
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="操作" align="center">
        <template slot-scope="scope">
          <!-- <div class="btn"><el-button  size="small" icon="el-icon-edit" @click="onEdit(scope.row)" type="info" >编辑表单</el-button> </div> -->
          <!-- 这是给客服人员编辑的 -->
          <div>
            <el-button
              type="text"
              size="mini"
              v-if="roleList[path].includes('_Set_CustomerService')"
              @click="handleEditPerson(scope.row)"
              >编辑</el-button
            >
          </div>
          <div>
            <el-button
              type="text"
              size="mini"
              v-if="roleList[path].includes('_Change')"
              @click="onChangeStatus(scope.row)"
              >变更状态</el-button
            >
          </div>
          <!-- v-if="scope.row.status === 3" -->
          <div v-if="scope.row.status === 3">
            <el-button
              type="text"
              size="mini"
              @click="handleDistritution(scope.row)"
              v-if="roleList[path].includes('_Manual')"
              >人工分配</el-button
            >
          </div>

          <div
            class="lookDetails"
            v-if="
              scope.row.status > 3 &&
              scope.row.status != 6 &&
              scope.row.status != 4
            "
          >
            <el-button
              type="text"
              size="mini"
              @click="lookDetails(scope.row)"
              v-if="roleList[path].includes('_Detail')"
              >查看详情</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <Pagination ref="Pagination" />
    <!-- 编辑客服人员 -->

    <editPerson ref="editPerson" @fetchData="fetchData"></editPerson>
    <!-- 修改状态 -->
    <changeStatus ref="changeStatus" @fetchData="fetchData" />

    <manualAllocation ref="manualAllocation" @fetchData="fetchData" />

    <!-- 查看详情 -->
    <!--  v-if="detailObj" -->
    <!-- class="detail" -->
    <el-dialog
      title="详情"
      class="detail"
      :visible.sync="detailShow"
      width="30%"
    >
      <div class="detail-row">
        <span>备注: </span>{{ detailObj.reviewOpinion }}
      </div>
      <div class="detail-row">
        <span>到访时间:</span> {{ detailObj.arriveTime }}
      </div>
      <div class="detail-row">
        <span> 签约时间:</span> {{ detailObj.signedTime }}
      </div>
      <div class="detail-row">
        <span> 成交类型:</span> {{ detailObj.type === 1 ? '购' : '租' }}
      </div>
      <div class="detail-row">
        <span> 单价:</span> {{ detailObj.unitPrice }}
      </div>
      <div class="detail-row">
        <span> 总佣金:</span> {{ detailObj.totalBonus }}
      </div>
      <div class="detail-row">
        <span> 成交金额:</span> {{ detailObj.totalPrice }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="detailShow = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUserListApi, searchSignedApi } from '@/api/introduce';
const changeStatus = () => import('./components/changeStatus'); // 增加表单
const editPerson = () => import('./components/editPerson'); // 增加表单
const manualAllocation = () => import('./components/manualAllocation');
import Pagination from '@/components/Pagination'; // 分页
import { mapGetters } from 'vuex';
import SearchBar from './components/searchBar'; // 搜索框
import { decrypt } from '@/utils/encryp';

export default {
  components: {
    changeStatus,
    editPerson,
    manualAllocation,
    Pagination,
    SearchBar,
  },
  data() {
    return {
      list: null,
      listLoading: false,
      detailShow: false,
      // size和index用于计算编号
      pageSize: '',
      pageIndex: '',
      path: '',
      detailObj: {}, // 详情数据
      checkList: [], // 选中的列表
    };
  },
  created() {
    this.fetchData();
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },

  mounted() {
    document.querySelector('.el-table__body-wrapper').style.height = '580px';
  },

  computed: {
    ...mapGetters(['paginObj', 'statusList', 'roleList']),
  },

  watch: {
    // 当分页组件中页码或页容量发生改变时会重新发请求渲染页面
    paginObj: 'fetchData',
  },
  methods: {
    // 处理解密
    handledecrypt(str, isShowAllPhone = true) {
      // if (!str || str.indexOf('=') == -1) return str;
      let showStr = decrypt(str);
      return isShowAllPhone
        ? showStr
        : showStr.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },
    // 请求表单数据
    // searchBar会触发此方法
    async fetchData() {
      try {
        const areaId = localStorage.getItem('areaId')
          ? JSON.parse(localStorage.getItem('areaId')).areaId
          : '';
        this.listLoading = true;
        let res = await getUserListApi({
          pageSize: this.paginObj.pageSize,
          pageIndex: this.paginObj.pageIndex,
          ...this.fromSearchObj,
          areaId,
        });
        this.listLoading = false;
        if (res.code !== 200 || res.data == null) return;
        let { pageSize, pageIndex, dataList, totalCount } = res.data;
        this.list = dataList;
        this.pageSize = pageSize;
        this.pageIndex = pageIndex;
        this.$refs.Pagination.pageSize = pageSize;
        this.$refs.Pagination.pageIndex = pageIndex;
        this.$refs.Pagination.totalCount = totalCount;
      } catch (e) {
        this.listLoading = false;
        window.console.log(e);
      }
    },

    // 搜索
    search(obj = {}) {
      if (obj) this.fromSearchObj = obj;
      // 重置页码
      this.$store.dispatch('area/setPaginObj', {
        pageIndex: 1,
        pageSize: 20,
      });
    },
    handleSelectionChange(val) {
      this.checkList = val.map((item) => {
        return item.appRecordId;
      });
    },
    // 修改客服人员
    handleEditPerson(row) {
      // console.log(row);
      let { appRecordId, isSale, customerServiceName, customerServiceId } = row;
      this.$refs.editPerson.editForm.id = appRecordId;
      this.$refs.editPerson.editForm.isSale = isSale;
      this.$refs.editPerson.searchUser(customerServiceName);
      // a37a79c3-3642-4277-ab1f-793d5101ec14
      this.$refs.editPerson.editForm.customerServiceId = customerServiceId;
      this.$refs.editPerson.dialogFormVisible = true;
    },
    // 变更状态
    onChangeStatus(row) {
      this.$refs.changeStatus.dialogFormVisible = true;
      // this.$refs.changeStatus.value = [this.statusList[row.status]];
      // console.log('状态：', row.status, typeof row.status);
      this.$refs.changeStatus.childStatus = row.status;
      if (row.status === 4 || row.status === 6) {
        this.$refs.changeStatus.isTimeOut = true; //已失效或已过期变更需重新分配客服和销售
      }
      // console.log('row', row);
      this.$refs.changeStatus.editForm.opinion = row.remark;
      this.$refs.changeStatus.editForm.appRecordId = row.appRecordId;
    },

    // 人工分配
    handleDistritution(row) {
      this.$refs.manualAllocation.dialogFormVisible = true;
      // this.$refs.changeStatus.value = [this.statusList[row.status-1]]
      // this.$refs.changeStatus.editForm.opinion = row.remark
      this.$refs.manualAllocation.changeForm.appRecordId = row.appRecordId;
    },

    // 查看详情，只有已签约，可结佣，已结佣有这个功能
    async lookDetails(row) {
      await searchSignedApi(row.appRecordId).then((res) => {
        this.detailObj = res.data;
        if (this.detailObj) {
          // console.log(this.detailObj);
          this.detailShow = true;
        } else {
          this.$message.warning('暂无详情');
          // this.detailShow = false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.visit {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

/deep/ .el-checkbox__input {
  margin-left: 10px;
}

// 隐藏选择框的文字
/deep/ .el-checkbox__label {
  display: none;
}
/deep/ .el-table__body-wrapper {
  height: 460px !important;
}
.btn {
  margin-bottom: 10px;
}

.lookDetails {
  margin-top: 10px;
}

.detail {
  .detail-row {
    margin-top: 10px;
    display: flex;
    font-size: 16px;

    span {
      width: 100px;
      text-align: right;
      margin-right: 20px;
      font-weight: 550;
    }
  }
}
</style>
